import React, { useMemo, useRef } from 'react';
import ReactDOM from "react-dom";
import {compact, isEmpty} from "lodash";
import { useStoreState } from "easy-peasy";
import { types } from "../lib/store";
import {useTranslation} from "react-i18next";

function GeneralData() {
  const { t } = useTranslation();

  const { service_points, alternative_service_points } = useStoreState(state => state.selection.servicePoint);
  const showAlternativePoint = useStoreState(state => state.selection.showAlternativePoint);
  const fanWeight = useStoreState(state => state.selection[types.FAN_WEIGHT]);

  /* Reuse same ref on every render
   * https://github.com/facebook/react/issues/15110
   */
  const menuRef = useRef(null);

  if (!menuRef.current) {
    // Create once
    menuRef.current = document.getElementById("fan-general-data");
    menuRef.current.innerHTML = "";
  }

  const domElement = menuRef.current;

  const rpmOrAngle = useMemo(() => {
    const curves = showAlternativePoint ? compact(alternative_service_points || []) : compact(service_points || []);

    if (curves.length > 0) {
      const data = { ...curves[0]['rpm_angle'] };

      if (isEmpty(compact([data['rpm']])))
        data['rpm'] = null;

      if (isEmpty(compact([data['angle']])))
        data['angle'] = null;

      return data;
    }

    return {};
  }, [showAlternativePoint, service_points, alternative_service_points]);

  return ReactDOM.createPortal(
    <>
      {
        rpmOrAngle.rpm &&
        <div className="col-xs-6 col-md-3 col-lg-2">
          <div className="panel panel-info">
            <div className="panel-heading">
              RPM
            </div>
            <div className="panel-body">
              { rpmOrAngle.rpm_string }
            </div>
          </div>
        </div>
      }
      {
        rpmOrAngle.angle &&
        <div className="col-xs-6 col-md-3 col-lg-2">
          <div className="panel panel-info">
            <div className="panel-heading">
              { t('frontend:fan.angle') }
            </div>
            <div className="panel-body">
              { rpmOrAngle.angle_string }
            </div>
          </div>
        </div>
      }
      {
        fanWeight &&
        <div className="col-xs-6 col-md-3 col-lg-2">
          <div className="panel panel-info">
            <div className="panel-heading">
              { t('frontend:fan.weight') }
            </div>
            <div className="panel-body">
              { fanWeight } Kg
            </div>
          </div>
        </div>
      }
    </>
    , domElement
  );
}

export default GeneralData;
